import { formatBalance } from "@cede/utils";
import { TradeErrorType } from "@/types/trade";

interface ErrorMessageParams {
  tokenSymbol?: string;
  minAmount?: number;
  maxAmount?: number;
  balance?: number;
  exchangeName?: string;
  slippage?: number;
}

export const getTradeErrorMessage = (errorType: TradeErrorType, params: ErrorMessageParams = {}): string => {
  const { minAmount, maxAmount, tokenSymbol } = params;

  switch (errorType) {
    case TradeErrorType.INSUFFICIENT_BALANCE_FOR_MIN:
      return `Min trade: ${formatBalance(minAmount ?? 0, { roundForFiat: true })} ${tokenSymbol ?? ""}`.trim();

    case TradeErrorType.NO_TOKENS_AVAILABLE:
      return `No tokens available`;

    case TradeErrorType.AMOUNT_EXCEEDS_BALANCE:
      return `Insufficient balance`;

    case TradeErrorType.AMOUNT_BELOW_MINIMUM:
      return `Min trade: ${formatBalance(minAmount ?? 0, { roundForFiat: true })} ${tokenSymbol}`;

    case TradeErrorType.AMOUNT_ABOVE_MAXIMUM:
      return `Max trade: ${formatBalance(maxAmount ?? 0, { roundForFiat: true })} ${tokenSymbol}`;

    case TradeErrorType.HIGH_SLIPPAGE:
      return `High slippage detected`;

    default:
      return "Invalid amount";
  }
};
